import ValueInput from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorSections/ComponentJsonLogicEditor/blocks/ValueInput';
import CaseDataManagerSchemaSelect from 'dashboard/components/CaseDataManagerSchemaSelect';
import { ConditionalRuleValueTypes, JsonLogicValue, RuleValueTypes } from 'dashboard/lib/workflows';
import { JsonSchema } from 'lib/json-schema';
import { assertNever } from 'lib/utils/types';

export const LOGIC_RULE_INPUT_ID = 'component-logic-rule-input';

interface FieldOrValueInputProps {
  formattedValue: JsonLogicValue;
  configType: ConditionalRuleValueTypes;
  jsonSchema: JsonSchema;
  fieldSchema: JsonSchema | null;
  disabled?: boolean;
  hasError: boolean;
  isMulti: boolean;
  onChange: (value: JsonLogicValue) => void;
}

const FieldOrValueInput = ({
  formattedValue,
  configType,
  jsonSchema,
  fieldSchema,
  disabled = false,
  hasError,
  isMulti,
  onChange,
}: FieldOrValueInputProps) => {
  switch (configType) {
    case RuleValueTypes.Value: {
      return (
        <ValueInput
          formattedValue={formattedValue}
          fieldSchema={fieldSchema}
          disabled={disabled}
          hasError={hasError}
          isMulti={isMulti}
          onChange={onChange}
        />
      );
    }
    case RuleValueTypes.Field: {
      return (
        <CaseDataManagerSchemaSelect
          id={`${LOGIC_RULE_INPUT_ID}__right-field`}
          inputValue={formattedValue?.toString() ?? ''}
          jsonSchema={jsonSchema}
          disabled={disabled}
          hasError={hasError}
          onValueChange={onChange}
          portal
        />
      );
    }
    default:
      assertNever(configType);
  }
};

export default FieldOrValueInput;
